import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "@mui/material/Skeleton";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import "../styles/StoryOverview.css";
import { ClickableContainer, PseudoLink } from "../components/StyledComponents";
import StoryDetails from "../DetailFunctions/StoryDetails";
import useFetchPaginatedElements from "../fetchFunction/OverviewFetch";
import Pagination from "../Pagination";

const validateStories = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data
    .map((item) => {
      const id = item?.id || null;
      const headline = item?.headline?.trim() || "Keine Überschrift verfügbar";
      const text = item?.text?.trim() || "Kein Text verfügbar";
      const imageUrl = item?.image_urls || null;
      const company = item?.company || "Keine Firma angegeben";
      const iconUrl = item?.iconUrl || null;

      if (!id || !headline) {
        return null;
      }

      return {
        id,
        headline,
        text,
        imageUrl,
        company,
        iconUrl,
      };
    })
    .filter(Boolean);
};

const StoriesOverview = ({ styling, companyAccessname }) => {



  const pageSize = 10;
  const displayLimit = 10;

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStoryId, setSelectedStoryId] = useState(null);
  const [showDetailPage, setShowDetailPage] = useState(false);

  const {
    loading,
    error,
    totalPages,
    stories: storyData,
  } = useFetchPaginatedElements(
    companyAccessname,
    "stories",
    currentPage,
    pageSize
  );
  useEffect(() => {
  }, [totalPages]);

  useEffect(() => {
    if (!showDetailPage) {
      window.scrollTo(0, 0);
    }
  }, [showDetailPage]);

  useEffect(() => {
  }, [storyData]);

  const validStories = validateStories(storyData).slice(0, displayLimit);

  const truncateText = (text, maxLength) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  if (loading) {
    return (
      <div>
        {Array.from(new Array(displayLimit)).map((_, index) => (
          <ClickableContainer key={index} styling={styling}>
            <Skeleton
              variant="text"
              width="80%"
              height={30}
              style={{ marginBottom: "10px" }}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width="100px"
              height="100px"
              style={{ marginBottom: "10px" }}
              animation="wave"
            />
            <Skeleton
              variant="text"
              width="80%"
              style={{ marginBottom: "10px" }}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width="60%"
              height={30}
              animation="wave"
            />
          </ClickableContainer>
        ))}
      </div>
    );
  }

  if (error) {
    return <p>Fehler: {error}</p>;
  }

  if (validStories.length === 0) {
    return <p>Keine Geschichten verfügbar.</p>;
  }

  return (
    <div>
      {!showDetailPage ? (
        <>
          {validStories.map((story, index) => (
            <ClickableContainer
              key={index}
              styling={styling}
              onClick={() => {
                setSelectedStoryId(story.id);
                setShowDetailPage(true);
              }}
            >
              <h3
                className="chapter-title"
                style={{ color: styling.textColor }}
              >
                {story.headline}
              </h3>
              <div className="story-content">
                {story.imageUrl && (
                  <img
                    src={story.imageUrl}
                    alt={story.headline || "Story image"}
                    className="story-image"
                  />
                )}
                <div className="story-text">
                  <p style={{ color: styling.textColor }}>
                    {truncateText(story.text, 150)}
                    </p>
                    </div>

              </div>
              <PseudoLink className="pseudo-link" styling={styling}>
                weiterlesen{" "}
                <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
              </PseudoLink>
            </ClickableContainer>
          ))}
          <div className="pagination-container">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              styling={styling}
              onChangePage={goToPage}
            />
          </div>
        </>
      ) : (
        <StoryDetails
          storyId={selectedStoryId}
          styling={styling}
          companyAccessname={companyAccessname}
          onClose={() => setShowDetailPage(false)}
        />
      )}
    </div>
  );
};

StoriesOverview.propTypes = {
  styling: PropTypes.shape({
    textColor: PropTypes.string,
    linkColor: PropTypes.string,
    linkHoverColor: PropTypes.string,
    chapterEntry: PropTypes.object,
    chapterTitle: PropTypes.object,
  }),
  companyAccessname: PropTypes.string.isRequired,
};

StoriesOverview.defaultProps = {
  styling: {
    textColor: "white",
    linkColor: "#007BFF",
    linkHoverColor: "#0056b3",
    chapterEntry: {
      marginBottom: "10px",
    },
  },
};

export default StoriesOverview;
